module.exports = __webpack_public_path__ + "static/media/waterfalldeco.f167ebde.jpg";